import React from 'react';
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import {useSelector} from "react-redux";
import SlaHeatMapChart from "./slaHeatMapChart";
import OSTotaisGrid from "../../../components/OSTotaisGrid";
import {Typography} from "@material-ui/core";
import SlaBubblesChart from "./slaBubblesChart";


const useStyles = makeStyles(theme => ({

    gridExterno: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 3,
        //backgroundColor: 'white',
        margin: '4px',
        // padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        width: '120px',
        alignItems: 'center'


    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'stretch',
    },
    mainChart: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'stretch'
        //backgroundColor: 'cyan'
    }


}));

const SLAView = () => {
    const classes= useStyles();
    const osSLA = useSelector(state => state.i4.osSLA);

    let OSforaSLA = 0;
    let OSokSLA = 0;


/*
    let series =[];
    let headers = [];


    if (osSLA.length > 0) {
        osSLA.map(os => {

            if (os.Horas <= os.tempoHr) { OSokSLA++} else { OSforaSLA++}

            let ixs = headers.findIndex(s => s.etapaAtual === os.etapaAtual);
        //    console.log("series",ixs, series);
            if (ixs < 0) {
                headers.push({
                    etapaAtual: os.etapaAtual,
                    peDescricao: os.peDescricao
                });
                series.push([]);
                series[series.length-1].push({
                    y: os.percentualDoSLA,
                    x: os.Horas ,
                    os: os
                });

            } else {
                series[ixs].push(
                    {
                        y: os.percentualDoSLA,
                        x: os.Horas,
                        os: os
                    }
                );
            }
        })
    }
*/

    let seriesBubbles = [];
    let headerBubbles = [];
    let OSok =0;
    let OSfora = 0;
    if (osSLA.length > 0) {




        osSLA
            .sort(function(a, b) {
                if (!a.Horas) { return 0; }
                if (a.Horas < b.Horas) { return -1; }
                if (a.Horas > b.Horas) { return 1; }
                return 0;

                // if (!a.processoEtapa) { return 0; }
                // if (a.processoEtapa.sequencia < b.processoEtapa.sequencia) { return -1; }
                // if (a.processoEtapa.sequencia > b.processoEtapa.sequencia) { return 1; }
                // return 0;
            })
            .map( (os,conta) => {

                if (os.Horas <= os.tempoHr) { OSokSLA++} else { OSforaSLA++}

            console.log("osLA.map",conta, os);
            console.log("bubbleHeaders ", headerBubbles);
            console.log("bubbleseries ",  seriesBubbles);


            OSok  = 0;
            OSfora = 0;
            if (os.Horas <= os.tempoHr) { OSok = 1; } else { OSfora = 1}
            let ixs = headerBubbles.findIndex(s => s.priId === os.priId);
            if (ixs < 0) {
                headerBubbles.push({
                    priId: os.priId,
                    priDescricao: os.priDescricao,
                    total :  1,
                    tempoHr: os.tempoHr,
                    OSok : OSok,
                    OSfora : OSfora
                });
                seriesBubbles.push([{
                    y: 1,
                    priId: os.priId,
                    x : os.tempoHr,
                    z: 0,
                    total: 0,
                    OSs: []
                }]);
                seriesBubbles[seriesBubbles.length-1].push({
                    y: 1, //os.percentualDoSLA,
                    x: os.Horas ,
                    priId: os.priId,
                    z: 1,
                    OSs: [os]
                });
            } else {
                headerBubbles[ixs] = {
                    ...headerBubbles[ixs],
                    total : headerBubbles[ixs].total++,
                    OSok : headerBubbles[ixs].OSok + OSok,
                    OSfora: headerBubbles[ixs].OSfora + OSfora,
                };

                let isx = seriesBubbles[ixs].findIndex( s => s.x === os.Horas);
                console.log("isx",isx);
                if (isx < 0) {
                    seriesBubbles[ixs].push({
                        y: 1, //os.percentualDoSLA,
                        x: os.Horas ,
                        priId: os.priId,
                        z: 1,
                        OSs: [os]
                    });
                } else {
                    let xOSs = seriesBubbles[ixs][isx].OSs;
                    if (xOSs) {
                        xOSs.push(os);
                    } else {
                        console.log("ERROR ixs isx", ixs, isx, os );
                    }
                    seriesBubbles[ixs][isx] = {
                        ...seriesBubbles[ixs][isx],
                        z : xOSs.length,
                        OSs :xOSs
                    }
                }



            }
        });
    }

    console.log("bubbleHeaders FINAL", headerBubbles);
    console.log("bubbleseries FINAL",  seriesBubbles);

         return (
            <Grid item container className={classes.gridExterno} xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid item className={classes.mainChart} container xs={9} sm={9} lg={9} xl={9}>
                        <Grid item className={classes.mainChart} container xs={12} sm={12} lg={12} xl={12}>
                                <Typography variant="h3"># ORDENS X TEMPO X PRAZO</Typography>
                        </Grid>
                            <Grid item className={classes.mainChart} container xs={12} sm={12} lg={12} xl={12}>
                                <SlaBubblesChart series={seriesBubbles} headers={headerBubbles}/>
                            </Grid>
                    </Grid>
                    <Grid item container className={classes.operadores} xs={3} sm={3} lg={3} xl={3}>
                        <OSTotaisGrid dados={OSokSLA} titulo={"PRAZO OK"} styleTitulo={ {color: 'green'}} legenda={"PNEUS"} />
                        <OSTotaisGrid dados={OSforaSLA} titulo={"FORA PRAZO"} styleTitulo={ {color: 'red'}} legenda={"PNEUS"} />
                    </Grid>

                </Grid>
            </Grid>
        )
    }

export default SLAView;


